module.exports = __webpack_public_path__ + "static/media/6720.28100649.jpg";